/* eslint-disable @typescript-eslint/no-explicit-any */
import { h } from "vue";
import { Modal, type SpinProps } from "ant-design-vue";

import { useStore } from "@/store";

import { ConfigMutationTypes } from "@/store/modules/config/mutation-types";

import { isObject } from "./hooks/is";
import { logoutButKeep } from "@/enums/NoNeedLoginPageEnum";
import { RouterName } from "@/enums/RouterEnum";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
// import { setIsLogout } from "@/ipc/user";

export function loading() {
  const store = useStore();
  function setLoading(data: SpinProps | boolean = { spinning: true }) {
    let props: SpinProps = {
      spinning: false,
    };
    if (typeof data === "boolean") {
      props.spinning = data;
    } else if (isObject(data)) {
      props = data;
    }
    store.commit(ConfigMutationTypes.SET_SPIN_CONFIG, props);
  }
  window.$loading = setLoading;
}

export function verifyLogin(query: any = {}, router: any) {
  const searchIndex = window.location.href.indexOf("?");
  const returnUrl =
    searchIndex > 0
      ? window.location.href.substring(0, searchIndex)
      : window.location.href;
  const isLogin = localStorage.getItem("isLogin") === "1";
  if (!isLogin) {
    router.push({
      name: RouterName.LOGIN,
      query: { returnUrl, ...query },
    });
    return false;
  }
  return true;
}

const initStyles = () => {
  const styleId = "logout-dialog-styles";
  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    .logout-confirm-dialog .ant-btn {
      font-size: 12px !important;
      height: 30px !important;
    }
  `;
  document.head.appendChild(style);
};

const logoutConfirmDialog = (name: RouterName, router: any) => {
  initStyles();
  Modal.confirm({
    title: "退出登录",
    icon: null,
    class: "logout-confirm-dialog",
    content: h("div", { class: "f-c-s-s w100" }, [
      h("div", { class: "pt-3 pb-12 f-r-s-c" }, [
        h(ExclamationCircleOutlined, { style: { color: "#4749ad" } }),
        h("p", { class: "ml-2" }, "确定退出登录吗？"),
      ]),
    ]),
    okText: "确定",
    cancelText: "取消",
    onOk: () => {
      window.electronAPI.clearToken();
      handleLogout(name, router);
    },
    onCancel: () => {
      Modal.destroyAll();
    },
  });
};

export async function verifyLogout(
  name: RouterName,
  router: any,
  errorFlag?: boolean
) {
  // 如果是手动退出，需要判断是否有任务->询问是否确认关闭
  // 如果是token过期，直接退出
  if (!errorFlag) {
    const IS_ELECTRON = process.env.IS_ELECTRON === "true";
    if (IS_ELECTRON) {
      const shouldClose = await window.electronAPI.logout();
      if (shouldClose) {
        logoutConfirmDialog(name, router);
      }
    } else {
      handleLogout(name, router);
    }
  } else {
    handleLogout(name, router);
  }
}

async function handleLogout(name: RouterName, router: any) {
  const store = useStore() as any;
  console.log(logoutButKeep);
  const shouldGoLogin = !logoutButKeep.includes(name);
  const IS_ELECTRON = process.env.IS_ELECTRON === "true";
  if (IS_ELECTRON) {
    try {
      // 停止所有工作线程
      await window.electronAPI.stopAllWorkers();
      // 清理上传线程池
      await window.electronAPI.clearUploadThreadPool();
      // 清理上传协议实例（包括COS实例）
      await window.electronAPI.cleanupUploadProtocols();
      // 暂停所有下载任务（通过 workflow.stop()）
      await window.electronAPI.pauseAllDownloadTasks();
      // 清理下载线程池
      await window.electronAPI.clearDownloadThreadPool();
      // 关闭全局 Downloader
      await window.electronAPI.closeGlobalDownloader();
      // 设置登出状态
      await window.electronAPI.setIsLogout(true);
      // 清空会话ID
      await window.electronAPI.clearSessionId();
      // 清空token
      await window.electronAPI.clearToken();
    } catch (error) {
      console.error("Error during logout:", error);
    }
  } else {
    try {
      await store.dispatch("user/logout");
    } catch (error) {
      log.error("Error stopping workers during logout:", error);
    }
    if (shouldGoLogin) {
      const { LOGIN } = RouterName;
      router.push({ name: LOGIN });
    }
    localStorage.removeItem("chatRoomId");
    return;
  }
  setTimeout(() => {
    store.dispatch("user/logout");
  }, 0);
}
